// Phase 6 — Track E T-E3. Toaster — top-right viewport with the auto-dismiss
// 4-second default and stack of three (per blueprint §14.7).
//
// At v1 the Toaster is a no-op skeleton — the Track C dispatch ships the
// use-toast hook + the imperative `toast(opts)` helper. Phase 7 takes it
// further (success/error toasts on writes).

import * as React from 'react';
import {
  ToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
} from './Toast.js';

export interface ToasterToast {
  id: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  variant?: 'default' | 'danger';
}

interface ToasterProps {
  toasts?: readonly ToasterToast[];
  duration?: number;
}

export function Toaster({ toasts = [], duration = 4000 }: ToasterProps): JSX.Element {
  return (
    <ToastProvider duration={duration}>
      {toasts.map((t) => (
        <Toast key={t.id} variant={t.variant ?? 'default'}>
          <div className="flex flex-col gap-1">
            {t.title && <ToastTitle>{t.title}</ToastTitle>}
            {t.description && <ToastDescription>{t.description}</ToastDescription>}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
